import {Spinner} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'

import React from 'react'

const LoadingContainer = styled.div`
    background: ${({theme}) => theme.colors.background.primary};
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    padding: ${(props) => props.theme.size.grid002} 0;
    align-items: center;
    left: 0;
    top: 0;
    justify-content: center;
`

export function Loading(): JSX.Element {
    return (
        <LoadingContainer>
            <Spinner variant="x-large" />
        </LoadingContainer>
    )
}
